import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid'

import { CardHeader } from '~/components/Cards'
import TextField from '~/components/Fields/TextField'
import PageTitle from '~/components/PageTitle'
import Container, { Content, Header } from '~/components/Container'
import { withForm } from '~/components/Form'
import { DiscardButton, SaveButton } from '~/components/Buttons'
import * as NAV from '~/constants/nav-titles'

import { OperationField } from '../Fields'

function AdjustmentReasonCreateForm ({ pageTitle, pageTitleLoading, isLoading, form }) {
  const { t } = useTranslation()
  const { handleSubmit } = form

  return (
    <form onSubmit={handleSubmit}>
      <Container>
        <Header>
          <PageTitle
            parentTitle={t(NAV.CONFIGURATION)}
            pageTitle={pageTitle}
            pageTitleLoading={pageTitleLoading}
            rightButton={(
              <>
                <DiscardButton />
                <SaveButton disabled={isLoading} />
              </>
            )}
          />
        </Header>
        <Content>
          <Grid container={true} spacing={3}>
            <Grid item={true} xs={12} lg={6}>
              <Card>
                <CardHeader title={t('Details')} />
                <Divider />
                <CardContent>
                  <Grid container={true} spacing={3}>
                    <Grid item={true} xs={12}>
                      <TextField
                        name="name"
                        data-cy="name"
                        label="Name"
                      />
                    </Grid>
                    <Grid item={true} xs={12}>
                      <OperationField />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Content>
      </Container>
    </form>
  )
}

AdjustmentReasonCreateForm.propTypes = {
  pageTitle: PropTypes.string,
  form: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  pageTitleLoading: PropTypes.bool
}
export default withForm(AdjustmentReasonCreateForm)
